// src/services/analyticsV4Client.js
import axios from 'axios';
import { getAnalyticsV4Url } from '../config/config.js';
import { getSafeToken } from '../utils/tokenHelper';

const analyticsV4Client = axios.create({
  baseURL: `${getAnalyticsV4Url()}/analytics`,
  headers: {
    'Content-Type': 'application/json'
  }
});

analyticsV4Client.interceptors.request.use(
  (config) => {
    const token = getSafeToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

analyticsV4Client.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject(error)
);

export default analyticsV4Client;
